import React, { forwardRef, memo } from 'react'

const WhoShape = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="237.006"
      height="229.0805"
      viewBox="0 0 237.006 229.0805"
      fill="none"
      {...props}>
      <rect
        x="123.598629"
        y="74.76025"
        width="113.407371"
        height="155.319959"
        rx="2.2332439"
        fill="#78BE20"
      />
      <rect
        x="129.898525"
        y="82.156437"
        width="100.8068085"
        height="140.52609"
        fill="white"
      />
      <rect
        x="148.2526395"
        y="72.294677"
        width="64.0998155"
        height="14.7922505"
        rx="2.2332439"
        fill="#CEDC00"
      />
      <rect
        x="163.953937"
        y="62.3478825"
        width="33.60214125"
        height="17.25765345"
        rx="2.2332439"
        fill="#CEDC00"
      />
      <path
        d="M213.3519895 163.5133635H148.2526395L182.116026 134.1191665L213.3519895 163.5133635Z"
        fill="#72BF44"
      />
      <path
        d="M37.31197735 128.99898V126.533391C37.31197735 112.9171995 48.34883925 101.8803375 62.0340384 101.8803375V101.8803375C75.71923755 101.8803375 86.75609945 112.9171995 86.75609945 126.533391V134.1191665"
        stroke="#426C0D"
        strokeWidth="2.2332439"
        strokeLinejoin="round"
      />
      <rect
        x="0.3300808725"
        y="159.773177"
        width="118.338327"
        height="71.4959389"
        fill="#CEDC00"
      />
      <path
        d="M0.3300808725 151.6340115C0.3300808725 135.60094 13.32827865 122.6027425 29.3613501 122.6027425H89.635977C105.669049 122.6027425 118.6672468 135.60094 118.6672468 151.6340115V179.3062315H0.3300808725V151.6340115Z"
        fill="#78BE20"
      />
      <rect
        x="17.5878461"
        y="174.3752755"
        width="29.5845048"
        height="12.32685135"
        fill="#8712BF"
      />
      <rect
        x="71.825985"
        y="174.3752755"
        width="29.5845048"
        height="12.32685135"
        fill="#8712BF"
      />
      <path
        d="M134.658065 67.279518L38.5281848 102.295221L111.612941 9.08921829L134.658065 67.279518Z"
        stroke="#FFA300"
        strokeWidth="8.9329716"
        strokeLinejoin="round"
      />
    </svg>
  )
)

WhoShape.displayName = 'WhoShape'

export default memo(WhoShape)
